<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :tables="pageData"
      :isFooter="isFooter"
    >
      <template v-slot:[pageData[0].name]>
        <ClientInfo
          :recItems="recItems"
          :pageType="isHistoryType ? 'history' : 'register'"
        />
      </template>
      <template v-slot:[pageData[1].name]>
        <div class="productTableHeader">
          <ProductTable
            :headers="pageData[1].headers"
            :items="loadingItems"
            :item-key="pageData[1].itemKey"
          >
            <template v-slot:quantity="{ item }">
              {{ item.quantity }}
            </template>
            <template v-slot:quantityAndStorageNo="{ item }">
              <QuantityRackNumber
                v-if="isPossibleOperation"
                :rackNumberList="
                  productInputData[getProductInputDataIndex(item.productMoveId)]
                    .rackNumberList
                "
                @change="onChangeQuantityRackNumber(item.productMoveId, $event)"
                class="py-1 mx-2"
                :defaultQuantity="Number(item.quantity)"
              />
              <span v-else>-</span>
            </template>
            <template v-slot:productLotNumber="{ item }">
              <v-text-field
                class="px-2"
                outlined
                dense
                hide-details
                v-model="
                  productInputData[getProductInputDataIndex(item.productMoveId)]
                    .productLotNumber
                "
                :disabled="!isPossibleOperation"
              />
            </template>
            <template v-slot:productExpiredDate="{ item }">
              <NormalDatePicker
                class="px-2"
                width="100%"
                v-model="
                  productInputData[getProductInputDataIndex(item.productMoveId)]
                    .productExpiredDate
                "
                :disabled="!isPossibleOperation"
              />
            </template>
            <template v-slot:productPrice="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <label
                    v-if="authority.isOutsideStaff"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon>mdi-information</v-icon>*****</label
                  >
                </template>
                <span>{{
                  $t('stock-adjust.stock-adjust_adjust-tooltip-message')
                }}</span>
              </v-tooltip>
              <v-text-field
                v-if="!authority.isOutsideStaff"
                class="px-2"
                outlined
                dense
                hide-details
                v-model="
                  productInputData[getProductInputDataIndex(item.productMoveId)]
                    .productPrice
                "
                :disabled="!isPossibleOperation"
              />
            </template>
            <template v-slot:productCurrency="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <label
                    v-if="authority.isOutsideStaff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-information</v-icon>
                    {{
                      productInputData[
                        getProductInputDataIndex(item.productMoveId)
                      ].productCurrency.label
                    }}
                  </label>
                </template>
                <span>{{
                  $t('stock-adjust.stock-adjust_adjust-tooltip-message')
                }}</span>
              </v-tooltip>
              <SelectCurrency
                v-if="!authority.isOutsideStaff"
                class="px-2"
                v-model="
                  productInputData[getProductInputDataIndex(item.productMoveId)]
                    .productCurrency
                "
              />
            </template>
          </ProductTable>
        </div>
      </template>

      <template v-slot:[pageData[2].name]>
        <ShipTable
          :headers="pageData[2].headers"
          :propsItems="productInputDataForShip"
          :item-key="pageData[2].itemKey"
          @change="changeShipTable"
        />
      </template>

      <template v-slot:[pageData[3].name]>
        <v-row class="mx-3 my-2">
          <v-col cols="6">
            <Remarks title="" text="" v-model="remarks" />
          </v-col>
        </v-row>
      </template>

      <!-- TODO：この辺不要なら消したい -->
      <!-- 詳細のみ -->
      <!-- <template v-if="isHistoryType" v-slot:[pageData[3].name]="{ item }"> -->
      <!-- 出庫履歴 -->
      <!-- <slot :name="pageData[3].name" v-bind:item="item" />
      </template> -->
      <template v-if="isHistoryType" v-slot:[pageData[4].name]="{ item }">
        <!-- 入金履歴 -->
        <slot :name="pageData[4].name" v-bind:item="item" />
      </template>
      <template v-if="isHistoryType" v-slot:[pageData[5].name]="{ item }">
        <!-- 返金履歴 -->
        <slot :name="pageData[5].name" v-bind:item="item" />
      </template>

      <template #footer>
        <v-spacer></v-spacer>

        <NormalButton
          :text="$t('common.input_fix')"
          color="white"
          class="pr-5"
          textColor="thinText--text"
          height="50px"
          width="130px"
          @click="inputedValue.dialog = false"
        />
        <NormalButton
          :text="$t('common.input_save')"
          height="50px"
          width="130px"
          @click="register()"
        />
        <DialogAlertSuccess
          v-model="completeDialog"
          :text="$t('common.common_register-complete')"
        />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import MultipleAreaBase from '../MultipleAreaBase'

import ClientInfo from '@/components/layouts/ClientConfirmation/StorageInfo/CustomerInfoBase'
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'
import {
  ProductTable,
  Remarks,
  QuantityRackNumber,
  NormalDatePicker
} from '@/components/items'

import NormalButton from '@/components/items/Buttons/NormalButton'
import ShipTable from '@/components/items/Tables/ShipTable'
import { SelectCurrency } from '@/components/items/Selectboxes'
import { currencyUtil } from '@/util'

export default {
  components: {
    MultipleAreaBase,
    ClientInfo,
    // OperationDetail,
    ProductTable,
    Remarks,
    QuantityRackNumber,
    NormalDatePicker,
    NormalButton,
    ShipTable,
    DialogAlertSuccess,
    SelectCurrency
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    },

    pageData: {
      type: Array,
      require: true,
      default: () => []
    },

    // TODO：不要なら消す
    isHistoryType: { default: false },
    isFooter: { default: false },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    completeDialog: false,
    pageType: {
      en: 'sale',
      ja: '注文'
    },

    recDetail: {
      productListHeaders: [
        {
          text: 'product.product_product-number',
          value: 'product.productNumber',
          sortable: false,
          width: '8%',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        },
        {
          text: 'common.product_product-name',
          value: 'productName',
          sortable: false,
          width: '26%',
          class: 'rgba(151, 198, 234, 0.1)'
        },
        {
          text: 'common.product_capacity',
          value: 'product.capacity',
          sortable: false,
          width: '5%',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        },
        {
          text: 'loading.loading_loading-quantity-lot-number',
          value: 'quantityAndStorageNo',
          sortable: false,
          width: '8%',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'end'
        },
        {
          text: 'loading.loading_lot-number',
          value: 'productLotNumber',
          sortable: false,
          width: '8%',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        },
        {
          text: 'loading.loading_expiration-date',
          value: 'productExpiredDate',
          sortable: false,
          width: '8%',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        }
      ]
    },
    productInputData: [],
    productInputDataForShip: [],
    isPossibleOperation: true,
    loadingItems: [],

    remarks: ''
  }),
  methods: {
    ...mapActions('Sale', ['getRackNumberByProductFromApi']),
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapActions('Stock', ['registerStockAdjust']),
    ...mapActions('Common', ['setIsLoading']),
    ...mapGetters('Sale', ['getRackNumberByPaymentFromState']),
    ...mapGetters('User', ['getUserInfoFromState']),
    // register() {
    //   this.$emit('register')
    // },
    // cancel(id) {
    //   this.$emit('cancel', id)
    // },
    // edit(rec) {
    //   this.$emit('edit')
    // }
    init() {
      this.setProductInputData()
    },
    onChangeQuantityRackNumber(productMoveId, event) {
      const rackInfoList = event
      this.updateProductData(productMoveId, 'rackInfoList', rackInfoList)
    },
    updateProductData(productMoveId, updatePropertyNameName, updateData) {
      this.productInputData = this.productInputData.map((ele) => {
        if (ele.productMoveId === productMoveId) {
          ele[updatePropertyNameName] = updateData
        }
        return ele
      })
    },
    async getProductListForRackNumber() {
      // 対象発注履歴に紐づく全商品の棚番号一覧を取得
      const productIdList = this.recItems.productMoves.map((ele) => {
        return ele.product.productId
      })

      if (this.recItems.client.clientInfo.storageId) {
        await this.getRackNumberByProductFromApi({
          // 受取人を選択した場合としない場合でオブジェクトが異なるので注意
          storageId: this.recItems.client.clientInfo.storageId,
          productIdList: productIdList
        })
      }

      const productListForRackNumber = this.getRackNumberByPaymentFromState()
      return productListForRackNumber
    },
    async getRackNumber() {
      const productListForRackNumber = await this.getProductListForRackNumber()
      const allRackNumberList = productListForRackNumber.map((ele) => {
        return {
          productId: ele.productId,
          rackInfoList: ele.rackInfoList
        }
      })
      return allRackNumberList
    },
    async setProductInputData() {
      const allRackNumberList = await this.getRackNumber()
      const products = await this.getProductListFromApi()
      this.loadingItems = this.recItems.productMoves.filter((ele) => {
        return ele.quantity > 0
      })

      this.productInputDataForShip = this.recItems.productMoves
        .filter((ele) => {
          return ele.quantity < 0
        })
        .map((ele) => {
          return {
            productMoveId: ele.productMoveId,
            productId: ele.product.productId,
            quantity: Math.abs(ele.quantity),
            product: ele.product,
            productLotNumber: '',
            productExpiredDate: '',
            notYet: ele.quantity,
            rackInfoList: [],
            rackNumberList: this.getRackNumberListForShip(
              allRackNumberList,
              ele.product.productId,
              ele.quantity
            )
          }
        })

      this.productInputData = this.recItems.productMoves.map((ele) => {
        const product = products.data.find(
          (ele2) => ele2.productId == ele.product.productId
        )
        return {
          productMoveId: ele.productMoveId,
          productId: ele.product.productId,
          productLotNumber: '',
          productExpiredDate: '',
          rackInfoList: [],
          productCurrency: currencyUtil.getCurrencyIdInfo(
            ele.product.purchasePriceCurrencyId
          ),
          productPrice: product ? product.purchasePrice : '',
          rackNumberList: this.getRackNumberList(
            allRackNumberList,
            ele.product.productId
          )
        }
      })

      // const ret = this.productInputData.filter((ele) => ele.notYet > 0)
      // this.isPossibleOperation = ret.length > 0
    },
    getRackNumberList(allRackNumberList, productId) {
      // 対象商品が管理されている棚番号一覧
      const rackInfoList = allRackNumberList
        .filter((ele) => ele.rackInfoList.length > 0)
        .map((ele) => {
          ele.rackInfoList = ele.rackInfoList.filter((ele) => ele.rackNumber)
          return ele
        })
        .find((v) => {
          return v.productId === productId
        })
        ?.rackInfoList.map((rackInfo) => {
          return rackInfo.rackNumber
        })

      return rackInfoList ? rackInfoList : []
    },

    getRackNumberListForShip(allRackNumberList, productId, notYet) {
      // 対象商品が管理されている棚番号一覧
      const rackInfoList = allRackNumberList
        .filter((ele) => ele.rackInfoList.length > 0)
        // .map((ele) => {
        //   // ele.rackInfoList = ele.rackInfoList.filter((ele) => ele.rackNumber)
        //   return ele
        // })
        .find((v) => {
          return v.productId === productId
        })
        ?.rackInfoList.map((rackInfo, index) => {
          return { ...rackInfo, count: index === 0 ? Math.abs(notYet) : 0 }
        })

      return rackInfoList
        ? rackInfoList
        : [
            {
              rackNumber: '',
              quantity: 0,
              count: 0
            }
          ]
    },
    getProductInputDataIndex(productMoveId) {
      return this.productInputData.findIndex(
        (ele) => ele.productMoveId === productMoveId
      )
    },
    getProductInputDataForShipIndex(productMoveId) {
      return this.productInputDataForShip.findIndex(
        (ele) => ele.productMoveId === productMoveId
      )
    },
    changeShipTable(...args) {
      const [event, productMoveId, productId, rackNumber] = args

      const target =
        this.productInputDataForShip[
          this.getProductInputDataForShipIndex(productMoveId)
        ]
      target.rackNumberList = target.rackNumberList.map((ele) => {
        if (ele.rackNumber === rackNumber) {
          ele.count = event
        }
        return ele
      })
    },
    async register() {
      this.setIsLoading(true)
      const isSuccess = await this.registerStockAdjust({
        clientData: this.recItems.client,
        loadingData: this.productInputData,
        shipData: this.productInputDataForShip,
        remarks: this.remarks
      })
      if (isSuccess) {
        this.completeDialog = true
      }
      this.setIsLoading(false)
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    completeDialog: function (newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$router.push({ name: 'storage.adjust.history' })
        this.inputedValue.dialog = false
      }
    },
    'inputedValue.dialog': async function (val) {
      if (val) await this.init()
    }
  }
}
</script>
<style lang="scss" scoped>
// .productTableCom {
//   ::v-deep .v-data-table th {
//     background-color: rgba(151, 198, 234, 0.1);
//     padding-left: 30px;
//   }
//   ::v-deep .v-data-table td {
//     padding-left: 30px;
//   }
// }
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 90px;
}
.productTableHeader {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    padding: 0 !important;
  }
}
</style>
